import { createContext, useEffect, useState, useReducer } from 'react';
import {
  REGIONS_INITIAL_STATE,
  DATE_INITIAL_STATE,
  listReducer,
} from './utils';
import moment from 'moment';
import apiService from 'services/apiService';

export const FiltersContext = createContext();

export default function FiltersProvider(props) {
  const [regionState, regionDispatch] = useReducer(
    listReducer,
    REGIONS_INITIAL_STATE
  );
  const [filters, setFilters] = useState([]);
  const [dateState, setDateState] = useState(DATE_INITIAL_STATE);

  async function fetchAllRegions() {
    try {
      const response = await apiService.get(`region`);
      const regionsToSet = {};
      response.data.forEach((regionName) => {
        regionsToSet[regionName.name] = regionName._id;
      });
      regionDispatch({ type: 'ADD_ALL', value: regionsToSet });
    } catch (error) {
    } finally {
    }
  }

  const handleDateSelection = (e) => {
    setDateState((prev) => {
      return {
        ...prev,
        selectedList: {
          startDate: moment(e.startDate).format('YYYY-MM-DD'),
          endDate: moment(e.endDate).format('YYYY-MM-DD'),
        },
      };
    });
  };

  const removeDate = () => {
    setDateState({
      title: 'Date',
      hasSubMenu: false,
      selectedList: {},
    });
  };

  useEffect(() => {
    // fetchAllTeams();
    fetchAllRegions();
  }, []);

  return (
    <FiltersContext.Provider
      value={{
        props,
        state: [
          regionState,
          dateState, // intentionally adding this here
        ],
        dispatch: [regionDispatch],
        date: { dateState, handleDateSelection, removeDate }, // intentionally adding this here
      }}
    >
      {props.children}
    </FiltersContext.Provider>
  );
}
